import { jsx as t } from "react/jsx-runtime";
function C(e) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "15",
      height: "17",
      viewBox: "0 0 15 17",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.3613 1.63892H12.5419V0H10.903V1.63892H4.3473V0H2.70838V1.63892H1.88892C0.97932 1.63892 0.25 2.37643 0.25 3.27784V14.7502C0.25 15.6516 0.97932 16.3892 1.88892 16.3892H13.3613C14.2627 16.3892 15.0002 15.6517 15.0002 14.7502V3.27784C15.0002 2.37644 14.2627 1.63892 13.3613 1.63892H13.3613ZM7.62513 4.09729C8.98543 4.09729 10.0835 5.19536 10.0835 6.55566C10.0835 7.91596 8.98543 9.01403 7.62513 9.01403C6.26483 9.01403 5.16676 7.91596 5.16676 6.55566C5.16676 5.19536 6.26483 4.09729 7.62513 4.09729ZM12.5419 13.9308H2.70838V13.1113C2.70838 11.4724 5.98621 10.571 7.62513 10.571C9.26405 10.571 12.5419 11.4724 12.5419 13.1113V13.9308Z"
        }
      )
    }
  );
}
export {
  C as ContactIcon
};
